import { z } from 'zod';

import { AdvisorParticipantZod } from 'types/zod/advisor-participant';
import { AdvisorsGroupZod } from 'types/zod/advisors-group';

export const AdvisorsChangesZod = z.object({
    participants: z.array(AdvisorParticipantZod).optional(),
    groups: z.array(AdvisorsGroupZod).optional(),
});
export type AdvisorsChanges = z.infer<typeof AdvisorsChangesZod>;
